import React from "react";
import { KTSVG } from "../../../helpers/KTSVG";
import Text from "../../../styleguide/Text";
import {
  getSemanticIconClasses,
  getSemanticSubtleBackgroundClasses,
} from "../../../theme/semanticClasses";
import SelectableChecker from "./SelectableChecker";

export interface OnSelectableItemClick {
  value?: number;
  items?: any[];
  checked?: boolean;
  name?: string;
}

interface SelectableItem {
  type?: "checkbox" | "radio";
  name: string;
  icon?: {
    name: string;
    backgroundColor?:
      | "light-primary"
      | "light-secondary"
      | "light-info"
      | "light-success"
      | "light-warning"
      | "light-danger"
      | "light-light"
      | "light-dark";
    color?:
      | "primary"
      | "secondary"
      | "info"
      | "success"
      | "warning"
      | "danger"
      | "light"
      | "dark";
  };
  title?: string;
  subtitle?: string;
  value?: number;
  checked?: boolean;
  onClick?: (value: OnSelectableItemClick) => void;
  items?: any[];
  className?: string;
}

export const getNewItemsWithCategory = (
  name: string,
  categoryItems: any[],
  newRadioItems: any[],
) => {
  const newItems = categoryItems.map((problemsItem: any) => {
    if (problemsItem.type === name && newRadioItems) {
      return {
        ...problemsItem,
        reasons: newRadioItems,
      };
    } else {
      return problemsItem;
    }
  });

  return newItems;
};

function SelectableItem({
  type = "checkbox",
  name,
  icon,
  title,
  subtitle,
  value,
  checked = false,
  onClick,
  items,
  className,
}: SelectableItem) {
  const getNewRadioItems = () => {
    if (!items || items?.length === 0) {
      return [];
    }
    const newItems = items.map((newItem) => {
      if (newItem.value === value) {
        return {
          ...newItem,
          checked: true,
        };
      } else {
        return {
          ...newItem,
          checked: false,
        };
      }
    });

    return newItems;
  };

  const getNewCheckboxItems = () => {
    if (!items || items?.length === 0) {
      return [];
    }
    const newItems = items.map((newItem) => {
      if (newItem.value === value) {
        return {
          ...newItem,
          checked: !newItem.checked,
        };
      } else {
        return newItem;
      }
    });

    return newItems;
  };

  const onSelectableClick = () => {
    const itemsFormated =
      type === "radio" ? getNewRadioItems() : getNewCheckboxItems();
    onClick && onClick({ value, checked, name, items: itemsFormated });
  };

  return (
    <label
      className={`mb-6 flex cursor-pointer items-center justify-between ${
        className ?? ""
      }`}>
      <span className="mr-2 flex min-w-0 items-center">
        {icon && (
          <span className="mr-6 inline-flex h-[50px] w-[50px] shrink-0">
            <span
              className={`flex h-full w-full items-center justify-center rounded-control ${getSemanticSubtleBackgroundClasses(
                icon.backgroundColor ?? "light-primary",
              )}`}>
              <KTSVG
                path={icon.name}
                className={getSemanticIconClasses(icon.color ?? "primary")}
                svgClassName="h-6 w-6"
              />
            </span>
          </span>
        )}

        <span className="flex min-w-0 flex-col">
          <Text
            variant="body1"
            component="span"
            className="text-base font-semibold text-slate-800">
            {title ?? value}
          </Text>
          {subtitle && (
            <Text
              variant="body2"
              component="span"
              className="mt-1 text-sm font-normal text-muted">
              {subtitle}
            </Text>
          )}
        </span>
      </span>
      <SelectableChecker
        type={type}
        name={name}
        value={value}
        checked={checked}
        onChange={onSelectableClick}
      />
    </label>
  );
}

export default SelectableItem;
